

































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import VehiclesForSuscription from './VehiclesForSuscription.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { UserCompaniesReports } from '../models';
import { ReportsServices } from '../api/ReportsServices';

@Component({
    components: {
        SimpleTable,
        Button
    }
})
export default class ReportsCompanyPicker extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: '' }) templateName: string
    @Prop({ default: 'Guardar' }) submitName: string;
    @Prop({ default: 0 }) templateId: number
    @Prop({ default: false }) pendingAction: boolean
    @Prop({ default: false }) exportable: boolean
    @Prop() submitFunction: Function;
    pendingCompanies: boolean = false;
    searchCompanies: string = '';
    allowSubmit: boolean = false;
    selectedCompanies: Array<UserCompaniesReports> = [];
    headers: any = [
        {
            text: 'Empresa',
            value: 'name',
            align: 'left',
            sortable: true
        },
        {
            text: 'Suscrita',
            value: 'subscribed',
            align: 'center',
            sortable: true
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: false,
            width: '150px'
        }
    ];
    itemsUserCompaniesReports: Array<UserCompaniesReports> = [];
    errorMsg: string = '';

    changeErrorMsg(msg: string) {
        console.log("reports picker", msg);
        this.errorMsg = msg;
    }


    get tooltipText() {
        return (checked: boolean) => {
            let msg = "";
            if(this.exportable) {
                msg = `${checked ? 'No incluir en exportacion' : 'Marcar para exportar'}`
            }else{
                msg = `Marcar para ${checked ? 'desactivar' : 'activar'}`
            }

            return msg
        }
    }

    updateCheckedCompanies() {
        let companiesChecked = this.itemsUserCompaniesReports.filter(item => item['checked'] === true);
        this.$emit('checked-companies', companiesChecked);
        return companiesChecked;
    }

   

    mounted() {
        this.pendingCompanies = true;
        ReportsServices.getUserCompaniesReports(
            this.templateName
        ).then((response: Array<UserCompaniesReports>) => {
            response = response.map(item => {
                item['checked'] = item.subscribed;
                return item;
            });
            this.itemsUserCompaniesReports = response;
            this.updateCheckedCompanies();
        }).catch((error: any) => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudieron obtener las empresas disponibles para suscribirse'
        });
        }).finally(() => {
            this.pendingCompanies = false;
        });
    }

    clickedCombo(item: UserCompaniesReports) { 
        this.updateCheckedCompanies();
    }

}
